import React, { useCallback, useMemo } from 'react';
import {
  AccordionItemContent,
  AccordionItemFooter,
  Avatar,
  EarningsByMonthContainer,
  FooterText,
  FooterTextContainer,
  ItemCard,
  ItemContentContainer,
  LeftContent,
  LeftContentEmpty,
  RightContent,
  TagText,
} from './ReferralsEarningsByMonth.styles';
import { Text14Regular, Text18Bold } from '../utils/Text/Text.styles';
import { formatPrice } from '../../utils/util';
import Spinner from '../Spinner/Spinner';
import Accordion from '../utils/Accordion/Accordion';
import { format, parse } from 'date-fns';
import { Tag } from '../ReferralInfo/ReferralInfo.styles';

const ReferralsEarningsByMonth = ({ pending, earningsData }) => {
  const renderAccordionItemContent = useCallback((data, totalEarningsGross) => {
    return (
      <AccordionItemContent>
        <ItemContentContainer>
          {data.map((item, index) => {
            return (
              <ItemCard key={index}>
                <LeftContent>
                  <Avatar src={item.profilePhoto} />
                  <Text14Regular>{item.name}</Text14Regular>
                </LeftContent>
                <RightContent>
                  <FooterTextContainer>
                    <Tag>
                      <TagText>LAYER {item.tier.split('_')[1]}</TagText>
                    </Tag>
                  </FooterTextContainer>
                  <FooterTextContainer>
                    <FooterText>Total: </FooterText>
                    <Text18Bold>${formatPrice(item.earnings)}</Text18Bold>
                  </FooterTextContainer>
                </RightContent>
              </ItemCard>
            );
          })}
        </ItemContentContainer>
        <AccordionItemFooter>
          <LeftContentEmpty />
          <FooterTextContainer></FooterTextContainer>
          <FooterTextContainer>
            <FooterText>Total: </FooterText>
            <Text18Bold>${formatPrice(totalEarningsGross)}</Text18Bold>
          </FooterTextContainer>
        </AccordionItemFooter>
      </AccordionItemContent>
    );
  }, []);

  const data = useMemo(() => {
    if (earningsData) {
      return Object.entries(earningsData).map(([key, value]) => {
        const parsedDate = parse(key, 'yyyy-MM', new Date());
        const monthName = format(parsedDate, 'MMMM');
        const totalEarningsGross = value.reduce((acc, curr) => acc + curr.earnings, 0);

        return {
          title: monthName,
          value: (
            <AccordionItemFooter>
              <FooterTextContainer></FooterTextContainer>
              <FooterTextContainer>
                <FooterText>Total: </FooterText>
                <Text18Bold>${formatPrice(totalEarningsGross)}</Text18Bold>
              </FooterTextContainer>
            </AccordionItemFooter>
          ),
          content: renderAccordionItemContent(value, totalEarningsGross),
        };
      });
    }

    return [];
  }, [earningsData, renderAccordionItemContent]);

  return (
    <EarningsByMonthContainer>
      {pending ? <Spinner width={150} height={150} /> : <Accordion items={data} openLastItem />}
    </EarningsByMonthContainer>
  );
};

export default ReferralsEarningsByMonth;
